import { useEffect, useMemo, useState } from 'react';

import {
  debugLog,
  type DisplayPlacementId
} from '@schibsted-nmp/advertising-shared';

import { $advItemIds } from '../atoms/index.js';
import type { AdSlot, ContainerId, PlacementId } from '../index.js';

export type RecommendationIds = ReturnType<typeof RecommendationIds.use>;

export namespace RecommendationIds {
  export function use(itemId: PlacementId) {
    const [adIndex, setAdIndex] = useState<number>(-1);

    useEffect(() => {
      const oldAdvtItemIds = $advItemIds.get();
      const newList = [...oldAdvtItemIds];

      if (!oldAdvtItemIds.includes(itemId)) {
        newList.push(itemId);
        $advItemIds.set(newList);
      }

      debugLog('AdvertisingRecircItemPageComponent', {
        itemId,
        oldAdvtItemIds,
        newList
      });

      setAdIndex(newList.indexOf(itemId));
    }, [itemId]);

    return useMemo(() => {
      if (adIndex === -1) return null;

      const placementId = `advt_recirc_middle_${adIndex + 1}` as
        | DisplayPlacementId.AdvtRecircMiddle1
        | DisplayPlacementId.AdvtRecircMiddle2
        | DisplayPlacementId.AdvtRecircMiddle3
        | DisplayPlacementId.AdvtRecircMiddle4
        | DisplayPlacementId.AdvtRecircMiddle5;

      const result = {
        adIndex,
        placementId,
        containerId: `${placementId}--container` as const satisfies ContainerId,
        slotId: `${placementId}--slot` as const satisfies AdSlot
      } as const;

      debugLog('useRecommendationIds', result);

      return result;
    }, [adIndex]);
  }
}
